const Login = require('./containers/Login');
const ForgotPassword = require('./containers/ForgotPassword');
const PasswordReset = require('./containers/PasswordReset');
const VerifyMfa = require('./components/VerifyMfa');
const PakistanNearpeerAttention = require('./components/PakistanNearpeerAttention');
const TokenNotExists = require('./components/TokenNotExists');
const LoginHelp = require('./components/LoginHelp');
const {
    getLoginContextWithQueryParams
} = require('utils/login-context');
const { context } = require('app-context');
const AuthConstants = require('services/auth-management/constants');
const RoutingTable = require('services/auth-management/routing-table');

const redux = context.redux.hooks;
const selectors = context.selectors.all;
const actions = context.actions;
const handlers = context.handlers;

exports = module.exports = [
    {
        path: AuthConstants.authFlow.routes.login.entry,
        exact: true,
        component: Login,
        onWillMount: () => exports.initLoginContext()
    },
    {
        path: AuthConstants.authFlow.routes.login.mfa,
        exact: true,
        component: VerifyMfa,
        onWillMount: () => exports.guardMfaRoute()
    },
    {
        path: '/forgot-password',
        component: ForgotPassword
    },
    {
        path: '/password-reset',
        component: PasswordReset
    },
    {
        path: '/login-help',
        component: LoginHelp,
        onWillMount: async () => {

            await redux.dispatch(actions.app.checkUserIp());
        }
    },
    {
        path: '/nearpeer-pakistan',
        component: PakistanNearpeerAttention
    },
    {
        path: '/reset-link-expired',
        component: TokenNotExists
    }
];

exports.guardMfaRoute = async () => {

    await exports.initLoginContext();

    const state = redux.getState();

    return RoutingTable.guardLoginMfaRoute({
        loginContext: selectors.getLoginContext(state) || {},
        signupContext: selectors.getSignupContext(state) || {}
    });
};

exports.initLoginContext = async () => {

    const loginContext = await getLoginContextWithQueryParams(context);
    redux.dispatch(actions.auth.updateLoginContext(loginContext));

    const signupContext = selectors.getSignupContext(redux.getState()) || {};

    if (loginContext?.mfaToken || signupContext.mfaToken) {
        return selectors.getLoginContext(redux.getState());
    }

    await handlers.auth.resolveIsAuthenticated();

    const {
        verificationToken,
        schoolId
    } = loginContext;

    await RoutingTable.ensureSchoolDetails({
        actions,
        redux,
        schoolId,
        selectors,
        verificationToken
    });

    return selectors.getLoginContext(redux.getState());
};
